import { LocationNumbersService } from '../../../services'

const fetchCallerIDs = async function (
  { commit, state, getters, dispatch },
  config
) {
  let tableConfig

  const { locationId, payload, getPaginatedDataOnly = false } = config

  /**
   * If payload is not provided, then we are fetching
   * the phone numbers from the state table
   */
  if (!payload) {
    tableConfig = {
      limit: state.table?.limit,
      page: state.table?.currentPage,
      query: state.table?.searchText ?? '',
    }
  }

  const table = payload ?? tableConfig

  if (getPaginatedDataOnly) {
    const list = await dispatch('fetchLocalCallerIDs', {
      paginationConfig: table,
    })
    return Promise.resolve(list)
  }

  commit('startLoading')
  try {
    const data = await LocationNumbersService.getCallerIDs(locationId)
    if (data && data.outgoingCallerIds) {
      commit('setCallerIDs', data.outgoingCallerIds)
      commit(
        'setTotalVerifiedCallerIDs',
        Object.keys(data?.outgoingCallerIds ?? {})?.length ?? 0
      )
      commit('setTableRecordsCount', data.outgoingCallerIds?.length)
      commit('setTable', payload ?? tableConfig)

      const result = getters.getPaginatedCallerIDs
      return Promise.resolve({ outgoingCallerIds: result })
      }

      commit('setCallerIDs', [])
      return Promise.resolve({ outgoingCallerIds: [] })
  } catch (error) {
    return Promise.reject(error)
  } finally{
    commit('stopLoading')
  }
}

export default fetchCallerIDs
